import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DetailsComponent } from './details/details.component';
import { ListComponent } from './list/list.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { HeaderComponent } from './header/header.component';
import { HttpClientModule} from '@angular/common/http';
import { ControlComponent } from './control/control.component'
import { NgDragDropModule } from 'ng-drag-drop';
import { DragDropModule} from '@angular/cdk/drag-drop';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { BuilderComponent } from './builder/builder.component'
import { FormsModule } from '@angular/forms';
import { MatTabsModule} from '@angular/material/tabs';
import { SettingComponent } from './setting/setting.component';
import { MessageComponent } from './message/message.component';
import { EditorMaterialModule } from './material.module';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { WorkflowToolbarComponent } from './toolbar/workflow/workflow-toolbar.component';
import { WorkflowBuilderComponent } from './workflow/builder/workflow-builder.component';
import { WorkflowHeaderComponent } from './header/workflow/workflow-header.component';
import { ComplexSettingsComponent } from './complex-settings/complex-settings.component';
import { WindowRef } from './windowref';
import { FormSelectorComponent } from './shared/form-selector/form-selector.component';
import { SSOLoginComponent } from './ssologin/ssologin.component';

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    DetailsComponent,
    ListComponent,
    ToolbarComponent,
    HeaderComponent,
    ControlComponent,
    BuilderComponent,
    SettingComponent,
    ComplexSettingsComponent,
    MessageComponent,
    WorkflowBuilderComponent,
    WorkflowToolbarComponent,
    WorkflowHeaderComponent,
    FormSelectorComponent,
    SSOLoginComponent    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgDragDropModule.forRoot(),
    DragDropModule,
    NgxDnDModule,
    FormsModule,
    MatTabsModule,
    EditorMaterialModule,
    BrowserAnimationsModule    
  ],
  entryComponents:[SettingComponent],
  providers: [WindowRef],
  bootstrap: [AppComponent]
})
export class AppModule { }
